import {
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
  Injector,
  DoCheck,
  AfterViewInit,
} from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { DataService } from './features/dfte-grid-view/config/data.service';
import {
  BasicAuthUserTokenPayload,
  IBasicAuthUserBackendTokenPayload,
  IBasicAuthUserTokenPayload,
  User,
} from './shared/constants/dfte-user-info';
import { BUS_MESSAGE_KEY } from './shared/constants/message-bus';
import { AuthenticationService } from './shared/services/authentication.service';
import { MessagingService } from './shared/services/messaging.service';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { jwtDecode } from 'jwt-decode';
import { MessageService } from './features/dfte-grid-view/services/message.service';
import { loginService } from './Login/login/login.service';
import { TokenService } from './token.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'dcon-portal';
  showLoader: BehaviorSubject<boolean>;
  userData: BehaviorSubject<boolean>;
  loggedUserId: any;
  loggedUserData: User;
  loggedUserBasicAuthData: IBasicAuthUserTokenPayload;
  apiCallInProgress: boolean;
  paramsObj: any = {};
  showerror: boolean = false;
  isTrainStopUrl: boolean = false;
  containerData$: Observable<any>;
  basicAuthUserData: IBasicAuthUserTokenPayload | any;
  localBasicAuth: boolean = false;

  showFooter: boolean = true; // New property to control footer visibility
  authService: AuthenticationService;
  isLoginPage: boolean = false;
  tokenCheckInterval: any;
  currentTime: any;
  tokenExpiryTime: any;

  constructor(
    private messagingService: MessagingService,
    private activatedRoute: ActivatedRoute,
    private injector: Injector,
    private _data: DataService,
    private router: Router,
    private cookieService: CookieService,
    private messageService: MessageService,
    private loginService: loginService,
    private tokenService: TokenService
  ) {
    if (!environment.isBasicAuth) {
      this.authService = <AuthenticationService>(
        this.injector.get(AuthenticationService)
      );
    }
    this.renderExternalScript();
  }

  ngOnInit() {
    this.localBasicAuth = environment.isBasicAuth;
    this.apiCallInProgress = true;
    this._data.apiCallInProgress = this.apiCallInProgress;
    document.getElementById('overlay').style.display = 'block';
    this.showLoader = this.messagingService.getBus(BUS_MESSAGE_KEY.LOADER);
    this.userData = this.messagingService.getBus(BUS_MESSAGE_KEY.USER_DETAILS);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLoginPage = this.router.url === '/login'; // Update '/login' if your login route is different
      }
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      if (Object.keys(params).length === 0 && params.constructor === Object) {
        const sessionType = sessionStorage.getItem('isTrainStopUrl');
        if (sessionType !== 'false') {
          sessionStorage.setItem('isTrainStopUrl', 'true');
          this._data.setisTrainStopUrl(true);
        } else {
          this._data.isTrainStopUrl = false;
          sessionStorage.setItem('isTrainStopUrl', 'false');
          sessionStorage.setItem('queryParams', null);
        }
      } else {
        const paramKeys = Object.keys(params);
        this.paramsObj[paramKeys[0]] = params[paramKeys[0]];
        this.paramsObj[paramKeys[1]] = params[paramKeys[1]];

        if (
          params[paramKeys[0]] != null &&
          params[paramKeys[0]] !== undefined
        ) {
          this._data.authProjectID.next(null);
          this._data.setisTrainStopUrl(true);
          this.isTrainStopUrl = true;
          sessionStorage.setItem('isTrainStopUrl', 'true');
          sessionStorage.setItem('queryParams', JSON.stringify(params));
          sessionStorage.setItem(paramKeys[0], params[paramKeys[0]]);
          sessionStorage.setItem(paramKeys[1], params[paramKeys[1]]);
        } else {
          this._data.isTrainStopUrl = false;
          sessionStorage.setItem('isTrainStopUrl', 'false');
          sessionStorage.setItem('queryParams', null);
          sessionStorage.setItem(paramKeys[0], null);
          sessionStorage.setItem(paramKeys[1], null);
        }
      }
    });

    this.messagingService.publish(BUS_MESSAGE_KEY.LOADER, false);
    if (environment.isBasicAuth) {
      this.triggerBasicAuth();
    } else {
      this.authService.initializeAuth();

      this.messagingService.subscribe(BUS_MESSAGE_KEY.USER_DETAILS, (data) => {
        this.userData = data;
        this.containerData$ = of({
          email: data.userId,
          name: data.userName,
        });
        this.loggedUserData = data;
        this._data.loggedUserId = this.loggedUserData.userId;
      });
    }

    // this.startTokenCheck();
    this.tokenService.tokenExpiration$.subscribe((isExpired) => {
      if (isExpired) {
        const token = localStorage.getItem('authToken');
        if (token) {
          this.handleExpiredToken(token);
        }
      }
    });
        // Initial token check
        this.tokenService.checkTokenExpiration().subscribe((isExpired) => {
          if (isExpired) {
            const token = localStorage.getItem('authToken');
            if (token) {
              this.handleExpiredToken(token);
            }
          }
        });
    
  }
  // startTokenCheck() {
  //   this.tokenCheckInterval = setInterval(() => {
  //     const token = localStorage.getItem('authToken');
  //     if (token) {
  //       const decodedToken: IBasicAuthUserBackendTokenPayload =
  //         jwtDecode(token);
  //       this.currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
  //       this.tokenExpiryTime = decodedToken.exp;

  //       if (this.tokenExpiryTime <= this.currentTime) {
  //         this.handleExpiredToken(token);
  //       }
  //     }
  //   }, 120000);
  // }
  privacyStatus(privacyStatus: CustomEvent) {
    this.messagingService.publish(
      BUS_MESSAGE_KEY.PRIVACY_STATUS,
      privacyStatus.detail
    );
  }

  renderExternalScript() {
    // const script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.src = environment.blobStorage.privacyjs;
    // script.async = true;
    // script.defer = true;
    // this.renderer2.appendChild(document.head, script);
  }

  ngOnDestroy() {
    this.authService.cleanListerners();
  }

  triggerBasicAuth(): void {
    const token = localStorage.getItem('authToken');
    if (!token) {
      console.log('No token found. Redirecting to login.');
      this.router.navigate(['/login']);

      return;
    }

    try {
      const decodedToken: IBasicAuthUserBackendTokenPayload = jwtDecode(token);
      console.log('Decoded Token:', decodedToken);

      this.currentTime = Math.floor(Date.now() / 1000);
      this.tokenExpiryTime = decodedToken.exp - 60;

      if (decodedToken.exp && this.tokenExpiryTime > this.currentTime) {
        console.log('Token is valid. Proceeding with authentication.');

        let refinedToken: IBasicAuthUserTokenPayload =
          this.mapTokenToInterface(decodedToken);

        this.basicAuthUserData = new BasicAuthUserTokenPayload(refinedToken);
        // this.setupAuthListeners();

        this.messagingService.publish(
          BUS_MESSAGE_KEY.USER_DETAILS,
          this.basicAuthUserData
        );
        this.messagingService.subscribe(
          BUS_MESSAGE_KEY.USER_DETAILS,
          (data) => {
            this.userData = data;
            this.containerData$ = of({
              email: data.email,
              name: data.userName,
            });
            this.loggedUserBasicAuthData = data;
            this._data.loggedUserId = this.loggedUserBasicAuthData.email;
          }
        );

        this.cookieService.set(
          BUS_MESSAGE_KEY.USER_DETAILS,
          JSON.stringify(this.basicAuthUserData)
        );
        if (refinedToken.isFirstLogin) {
          this.router.navigateByUrl('/login');
        } else this.router.navigate(['/']);
      } else {
        this.handleExpiredToken(token);
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      this.router.navigate(['/login']);
    }
  }

  mapTokenToInterface(token) {
    const mappedToken = { ...token };

    mappedToken.isAdmin = Boolean(mappedToken.isAdmin);
    mappedToken.isUserActive = Boolean(mappedToken.isUserActive);
    mappedToken.isFirstLogin = Boolean(mappedToken.isFirstLogin);
    // mappedToken.isLoggedIn = Boolean(mappedToken.isLoggedIn);

    mappedToken.email = mappedToken.username;
    mappedToken.userName = mappedToken.name;

    return mappedToken;
  }

  private handleExpiredToken(token: string): void {
    localStorage.removeItem('authToken'); // Clear the expired token
    localStorage.removeItem('isAdmin');
    this.router.navigate(['/login']);
    this.messageService.showMessage('Your session is expired, please relogin');
    this.loginService.logout().subscribe(() => {
      this.messageService.showMessage(
        'Your session is expired, please re-login',
        'error'
      );
      this.messagingService.publish(BUS_MESSAGE_KEY.USER_DETAILS, null);
    });
  }
}
